export default {
    userInfo: {
        url: '/blade-user/info',
        method: 'get'
    }
}